<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M756.7 374.4c8.9 15.3 4 34.9-11.2 44.1l-.5.3-200.6 117.3.1 230.4c.1 17.9-14.2 32.5-32.2 32.7-17.9.1-32.5-14.3-32.7-32.2V537.6l-202.9-119c-14.9-9.2-19.7-28.6-11-43.7 8.7-15.2 27.9-20.6 43.3-12.4l.5.3 201 118 201.8-118c15.5-9.1 35.3-3.9 44.4 11.6z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M874.4 254.7 548.2 81c-22.6-12-49.7-12-72.3 0L149.6 254.7c-25.1 13.4-40.8 39.5-40.8 68V693c0 27.9 15.2 53.6 39.6 67.2l326.1 182c23.4 13 51.8 13 75.1 0l326.1-182c24.4-13.5 39.5-39.3 39.5-67.2V322.6c0-28.4-15.7-54.6-40.8-67.9zm-32.1 438.2c0 1.5-.8 2.9-2.1 3.6L514 878.5c-1.2.6-2.7.6-3.9 0L183.9 696.6c-1.3-.7-2.1-2.1-2.1-3.6V322.7c0-1.5.8-2.9 2.2-3.6l326.1-173.7 1.9-.5-1.9.4c1.2-.6 2.6-.6 3.8 0l326.3 173.8c1.3.7 2.1 2.1 2.1 3.6v370.2z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="m745.5 418.5-.5.3-200.6 117.3.1 230.4c.1 17.9-14.2 32.5-32.2 32.7-17.9.1-32.5-14.3-32.7-32.2V537.6l-202.9-119c-14.9-9.2-19.7-28.6-11-43.7 8.7-15.2 27.9-20.6 43.3-12.4l.5.3 201 118 201.8-118c15.5-9.1 35.3-3.9 44.4 11.6 8.9 15.3 4 34.9-11.2 44.1z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="m745.5 418.5-.5.3-200.6 117.3.1 230.4c.1 17.9-14.2 32.5-32.2 32.7-17.9.1-32.5-14.3-32.7-32.2V537.6l-202.9-119c-14.9-9.2-19.7-28.6-11-43.7 8.7-15.2 27.9-20.6 43.3-12.4l.5.3 201 118 201.8-118c15.5-9.1 35.3-3.9 44.4 11.6 8.9 15.3 4 34.9-11.2 44.1z" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
